/* Collection filter and sort.
   Every change reloads only the product grid (Shopify Section Rendering API),
   so sorting and filtering apply right away without a full page load.
   Any extra URL params (like a theme preview id) are kept on every request,
   which keeps the draft theme in view while you test it. */
(function () {
  'use strict';
  var root = document.querySelector('[data-coll]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var defaultSort = root.getAttribute('data-default-sort') || '';
  var drawer = root.querySelector('[data-cf]');
  var form = root.querySelector('[data-cf-form]');
  var timer = null;
  var ctrl = null;
  var lastFocus = null;

  function isOwnParam(k) { return k.indexOf('filter.') === 0 || k === 'sort_by' || k === 'page' || k === 'section_id'; }

  // Params on the current URL that are not ours (preview ids, tracking, etc.)
  function keptParams() {
    var out = new URLSearchParams();
    new URLSearchParams(window.location.search).forEach(function (v, k) { if (!isOwnParam(k)) out.append(k, v); });
    var S = window.Shopify;
    if (S && S.theme && S.theme.role && S.theme.role !== 'main' && !S.designMode && !out.has('preview_theme_id')) {
      out.set('preview_theme_id', S.theme.id);
    }
    return out;
  }

  function formParams() {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) {
      v = String(v).trim();
      if (v === '') return;
      if (k === 'sort_by' && v === defaultSort) return;
      p.append(k, v);
    });
    return p;
  }

  function ownParamsFrom(url) {
    var p = new URLSearchParams();
    new URL(url, window.location.href).searchParams.forEach(function (v, k) {
      if (isOwnParam(k) && k !== 'section_id') p.append(k, v);
    });
    return p;
  }

  function openStates() {
    var map = {};
    root.querySelectorAll('[data-cf-body] details[data-key]').forEach(function (d) { map[d.getAttribute('data-key')] = d.open; });
    return map;
  }

  function swap(doc) {
    var open = openStates();
    var body = root.querySelector('[data-cf-body]');
    var scrollTop = body ? body.scrollTop : 0;
    var focus = document.activeElement;
    var focusSel = focus && focus.name ? 'input[name="' + focus.name + '"][value="' + String(focus.value).replace(/"/g, '\\"') + '"]' : null;
    if (focus && focus.type === 'number') focusSel = null;

    ['[data-cbar]', '[data-cf-body]', '[data-cf-foot]', '[data-cf-results]'].forEach(function (sel) {
      var fresh = doc.querySelector(sel);
      var old = root.querySelector(sel);
      if (fresh && old) old.replaceWith(fresh);
    });

    root.querySelectorAll('[data-cf-body] details[data-key]').forEach(function (d) {
      var k = d.getAttribute('data-key');
      if (Object.prototype.hasOwnProperty.call(open, k)) d.open = open[k];
    });
    var nb = root.querySelector('[data-cf-body]');
    if (nb) nb.scrollTop = scrollTop;
    if (focusSel && drawer.classList.contains('is-open')) {
      var f = root.querySelector(focusSel);
      if (f) f.focus({ preventScroll: true });
    }
  }

  function load(own, opts) {
    opts = opts || {};
    var all = keptParams();
    own.forEach(function (v, k) { all.append(k, v); });
    var qs = all.toString();
    var pageUrl = window.location.pathname + (qs ? '?' + qs : '');
    var fetchUrl = window.location.pathname + '?' + (qs ? qs + '&' : '') + 'section_id=' + encodeURIComponent(sectionId);

    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    root.classList.add('is-loading');

    return fetch(fetchUrl, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector('[data-cf-results]')) throw new Error('bad response');
        swap(doc);
        if (opts.push !== false) window.history.pushState({ cf: true }, '', pageUrl);
        root.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('thvsn:grid-updated'));
        if (opts.scroll) {
          var top = root.querySelector('[data-cbar]').getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = pageUrl; // fall back to a normal page load
      });
  }

  function apply(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () { timer = null; load(formParams()); }, delay || 0);
  }

  /* drawer */
  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var x = drawer.querySelector('.cf__x');
    if (x) setTimeout(function () { x.focus(); }, 50);
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus && document.body.contains(lastFocus)) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cf-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cf-close]')) { e.preventDefault(); closeDrawer(); return; }
    var link = e.target.closest('a[data-cf-link]');
    if (link) {
      e.preventDefault();
      clearTimeout(timer);
      load(ownParamsFrom(link.href), { scroll: link.hasAttribute('data-cf-scroll') || !drawer.classList.contains('is-open') });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* sort dropdown in the bar: mirrors the Sort by list in the drawer */
  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-cf-sort]');
    if (!sel) return;
    var radio = form.querySelector('input[name="sort_by"][value="' + sel.value + '"]');
    if (radio) radio.checked = true;
    var val = root.querySelector('.cbar__sort-val');
    if (val) val.textContent = sel.options[sel.selectedIndex].text;
    apply(0);
  });

  /* any change inside the drawer applies right away */
  form.addEventListener('change', function (e) {
    var t = e.target;
    if (t.type === 'number') {
      var box = t.closest('.cf__price');
      if (box) {
        var ins = box.querySelectorAll('input');
        var lo = parseFloat(ins[0].value), hi = parseFloat(ins[1].value);
        if (!isNaN(lo) && !isNaN(hi) && lo > hi) { ins[0].value = hi; ins[1].value = lo; }
      }
      apply(500);
      return;
    }
    apply(80);
  });
  form.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.type === 'number') { e.preventDefault(); e.target.blur(); apply(0); }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (timer) { clearTimeout(timer); timer = null; load(formParams()).then(closeDrawer); }
    else closeDrawer();
  });

  window.addEventListener('popstate', function () {
    load(ownParamsFrom(window.location.href), { push: false });
  });
})();
